import { setIsNotifyMeLoaded } from '@yme/pdp-components/ProductCard';
import { NOTIFY_ME_BACK_IN_STOCK_ENDPOINT, NOTIFY_ME_PRODUCT_RELEASE_ANNOUNCEMENT_ENDPOINT, } from '../../../../common/endpoints';
import { FAILED_TYPE, SUCCESS_TYPE } from './constants';
export const setBackInStockNotification = (payload, onSwitchType, dispatchOffLoader) => fetch(NOTIFY_ME_BACK_IN_STOCK_ENDPOINT, {
    method: 'POST',
    headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(payload),
}).then(({ status }) => {
    dispatchOffLoader(setIsNotifyMeLoaded(false));
    if (status === 200) {
        onSwitchType(SUCCESS_TYPE);
    }
    if (status !== 200) {
        onSwitchType(FAILED_TYPE);
    }
});
export const setProductReleaseNotification = (payload, onSwitchType, dispatchOffLoader) => fetch(NOTIFY_ME_PRODUCT_RELEASE_ANNOUNCEMENT_ENDPOINT, {
    method: 'POST',
    headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(payload),
}).then(({ status }) => {
    dispatchOffLoader(setIsNotifyMeLoaded(false));
    if (status === 200) {
        onSwitchType(SUCCESS_TYPE);
    }
    if (status !== 200) {
        onSwitchType(FAILED_TYPE);
    }
});
